import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { AppCard, AppModal } from '@/layout/AppComponents';
import Translator from '../../../../../components/helpers/Translator';
import { Tab, Tabs } from 'react-bootstrap';
import styled from 'styled-components';

export default function ApplicableDateBlock(props) {
  const {
    plantObligationID,
    isH3 = false,
  } = props;
  const poLevel2 = useSelector(
    (state) =>
      state.currentPage?.plantObligationLevels?.level2?.[plantObligationID]
  );
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('obligation');

  const content = (
    <span
      className={
        poLevel2?.obligation?.obligationVersion?.hasPreviousVersion
          ? 'pointer'
          : ''
      }
      onClick={() =>
        poLevel2?.obligation?.obligationVersion?.hasPreviousVersion &&
        setShowModal(true)
      }
    >
      {`• ${ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name={
            poLevel2?.obligation?.obligationVersion?.hasPreviousVersion
              ? 'applicable.version.to.date'
              : 'applicable.from.date'
          }
          variables={{
            date: poLevel2?.obligation?.obligationVersion?.applicableDate,
          }}
        />
      )}${
        poLevel2?.obligation?.obligationVersion?.hasPreviousVersion
          ? ` - ${ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="applicable.version.to.date.check"
              />
            )}`
          : ''
      }`}
    </span>
  );

  return (
    <>
      {poLevel2?.obligation?.obligationVersion?.applicableDate && (
        <>
          {isH3 ? (
            <h3>{content}</h3>
          ) : (
            <div className="font-weight-bold text-danger">{content}</div>
          )}
        </>
      )}
      {poLevel2?.obligation?.obligationVersion?.hasPreviousVersion && (
        <AppModal
          show={showModal}
          size="xl"
          title={ReactDOMServer.renderToString(
            <Translator file="evaluation" name="obligation.name" />,
          )}
          onClose={() => setShowModal(false)}
        >
          <Tabs onSelect={(v) => setActiveTab(v)}>
            {poLevel2?.obligation?.obligationVersion?.nextObligation !==
              poLevel2?.obligation?.obligationVersion?.obligation && (
              <Tab
                eventKey="obligation"
                title={ReactDOMServer.renderToString(
                  <Translator file="evaluation" name="obligation.name" />,
                )}
                className="p-3 border border-top-0 bg-white"
              >
                <Container>
                  <div className="row">
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.version.to.date"
                            variables={{
                              date: poLevel2?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        {poLevel2?.obligation?.hasFormat ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                poLevel2?.obligation?.obligationVersion
                                  ?.obligation,
                            }}
                          />
                        ) : (
                          <div style={{ whiteSpace: 'pre-line' }}>
                            {
                              poLevel2?.obligation?.obligationVersion
                                ?.obligation
                            }
                          </div>
                        )}
                      </AppCard>
                    </div>
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.from.date"
                            variables={{
                              date: poLevel2?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              poLevel2?.obligation?.obligationVersion
                                ?.nextObligation,
                          }}
                        />
                      </AppCard>
                    </div>
                  </div>
                </Container>
              </Tab>
            )}
            {poLevel2?.obligation?.obligationVersion?.nextEvidence !==
              poLevel2?.obligation?.obligationVersion?.evidence && (
              <Tab
                eventKey="evidence"
                title={ReactDOMServer.renderToString(
                  <Translator file="module-legalCompliance" name="evidences" />,
                )}
                className="p-3 border border-top-0 bg-white"
              >
                <Container>
                  <div className="row">
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.version.to.date"
                            variables={{
                              date: poLevel2?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              poLevel2?.obligation?.obligationVersion?.evidence,
                          }}
                        />
                      </AppCard>
                    </div>
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.from.date"
                            variables={{
                              date: poLevel2?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              poLevel2?.obligation?.obligationVersion
                                ?.nextEvidence,
                          }}
                        />
                      </AppCard>
                    </div>
                  </div>
                </Container>
              </Tab>
            )}
            {poLevel2?.obligation?.obligationVersion?.nextNextDate !==
              poLevel2?.obligation?.obligationVersion?.nextDate && (
              <Tab
                eventKey="nextDate"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="module.lc.nextDate"
                  />,
                )}
                className="p-3 border border-top-0 bg-white"
              >
                <Container>
                  <div className="row">
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.version.to.date"
                            variables={{
                              date: poLevel2?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              poLevel2?.obligation?.obligationVersion?.nextDate,
                          }}
                        />
                      </AppCard>
                    </div>
                    <div className="col-lg-6">
                      <AppCard
                        header={
                          <Translator
                            file="module-legalCompliance"
                            name="applicable.from.date"
                            variables={{
                              date: poLevel2?.obligation?.obligationVersion
                                ?.applicableDate,
                            }}
                          />
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              poLevel2?.obligation?.obligationVersion
                                ?.nextNextDate,
                          }}
                        />
                      </AppCard>
                    </div>
                  </div>
                </Container>
              </Tab>
            )}
          </Tabs>
          {poLevel2?.obligation?.obligationVersion?.versionComment && (
            <div className="alert alert-info mt-3">
              {poLevel2?.obligation?.obligationVersion?.versionComment}
            </div>
          )}
        </AppModal>
      )}
    </>
  );
}

const Container = styled.div`
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  .card {
    border: 1px solid #ddd;
  }
`;
